export default __webpack_public_path__ + "static/media/backend.9d561509.svg";